import { useEffect, useRef } from "react";

const PORTAL = "[data-radix-popper-content-wrapper],[cmdk-root],[role=listbox]";
const ser = (v) => JSON.stringify(v ?? "");

// Completed manual edits (leaving the field, Enter, option picked) on [data-voice-field] wrappers; keystrokes never count.
export function useFieldEdits({ asst, values, describe, onManual }) {
  const known = useRef({});
  const after = useRef(null);
  const lastCommit = useRef({ k: null, t: 0 });
  const live = useRef(null);
  live.current = { asst, values, describe, onManual };
  const commit = (k, unit) => {
    const { asst: a, values: v, describe: d, onManual: m } = live.current;
    a?.endEdit();
    lastCommit.current = { k, t: Date.now() };
    const cur = ser(v[k]);
    if (cur === (known.current[k] ?? ser(""))) { a?.editIdle(); return; }
    known.current[k] = cur;
    const bad = !!unit?.querySelector('[aria-invalid="true"]');
    m(k, unit, bad);
    a?.manualEdit(d(k, unit, bad));
  };
  useEffect(() => {
    const k = after.current;
    if (!k) return;
    after.current = null;
    commit(k, document.querySelector(`[data-voice-field="${k}"]`));
  });
  const sync = (obj) => Object.entries(obj).forEach(([k, v]) => { known.current[k] = ser(v); });
  const reset = (obj) => { known.current = {}; sync(obj); };
  const begin = (k) => { const l = lastCommit.current; if (!(l.k === k && Date.now() - l.t < 600)) live.current.asst?.beginEdit(k); };
  const props = (k) => ({
    "data-voice-field": k,
    onFocusCapture: () => begin(k),
    onInputCapture: () => live.current.asst?.beginEdit(k),
    onKeyDownCapture: (e) => { if (e.key === "Enter" && e.target.tagName === "INPUT") commit(k, e.currentTarget); },
    onBlurCapture: (e) => {
      const to = e.relatedTarget;
      const unit = e.target.closest("[data-edit-unit]") || e.currentTarget;
      if (to && (unit.contains(to) || to.closest(PORTAL))) return;
      commit(k, e.currentTarget.contains(unit) ? unit : e.currentTarget);
    },
  });
  return { props, sync, reset, commit, commitSoon: (k) => { after.current = k; } };
}
